'use client';

import { submitPlace } from '@/services/supabase-service';
import useLocationStore from '@/store/locationStore';
import { useUserStore } from '@/store/user';
import { Place } from '@/types/type';
import { router } from 'expo-router';
import { useEffect, useState } from 'react';
import { Button, SafeAreaView, Text, TextInput, View } from 'react-native';

export default function CreatePlace() {
  const { user } = useUserStore();
  const { destinationCoordinates } = useLocationStore();
  const [placeData, setPlaceData] = useState<Place>({
    description: '',
    latitude: destinationCoordinates?.latitude ?? 0,
    longitude: destinationCoordinates?.longitude ?? 0,
    title: '',
    legal_notices: '',
    street: '',
    city: '',
    country: '',
    moderated: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [lnText, setLnText] = useState('');
  const [titleText, setTitleText] = useState('');
  const [descriptionText, setDescriptionText] = useState('');

  useEffect(() => {
    setPlaceData({
      ...placeData,
      description: descriptionText,
      title: titleText,
      legal_notices: lnText,
    });
  }, [descriptionText, lnText, titleText]);

  const handleSubmit = async () => {
    setIsLoading(true);

    try {
      submitPlace(placeData);
    } catch (error) {
      console.error('Error creating post:', error);
    } finally {
      setIsLoading(false);
      router.back();
    }
  };

  return (
    <SafeAreaView>
      <View className="max-w-2xl mx-auto p-4">
        <Text className="text-2xl font-bold mb-6">Create New Post</Text>

        <View>
          <Text className="block mb-2">Title</Text>
          <TextInput
            value={titleText}
            onChangeText={setTitleText}
            className="w-full p-2 border rounded"
          />
        </View>

        <View>
          <Text className="block mb-2">Description</Text>
          <TextInput
            value={descriptionText}
            onChangeText={setDescriptionText}
            className="w-full p-2 border rounded"
          />
        </View>

        <View>
          <Text className="block mb-2">legal_notices</Text>
          <TextInput
            value={lnText}
            onChangeText={setLnText}
            className="w-full p-2 border rounded"
          />
        </View>

        <View>
          <Text className="block mb-2">Street: {placeData.street}</Text>
          <Text className="block mb-2">City: {placeData.city}</Text>
          <Text className="block mb-2">Country: {placeData.country}</Text>
          <Text className="block mb-2">Latitude: {placeData.latitude}</Text>
          <Text className="block mb-2">Longitude: {placeData.longitude}</Text>
        </View>

        <Button disabled={isLoading} title="Create Place" onPress={handleSubmit}></Button>
      </View>
    </SafeAreaView>
  );
}
